import React from "react";

const DashboardDataTable = ({
  columns,
  rows,
  rowKey = "id",
  tableClassName = "",
  headerRowClassName = "",
}) => {
  return (
    <div className="w-full overflow-x-auto">
      <table className={["min-w-[760px] w-full border-collapse", tableClassName].join(" ")}>
        <thead>
          <tr className={["border-b border-[#E5E7EB]", headerRowClassName].join(" ")}>
            {columns.map((column) => (
              <th
                key={column.key}
                className={[
                  "px-4 py-3 text-left text-xs font-['Inter'] font-medium uppercase tracking-[0.6px] text-[#6B7280]",
                  column.headerClassName ?? "",
                ].join(" ")}
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((row) => (
            <tr key={row[rowKey]} className="border-b border-[#E5E7EB] last:border-b-0">
              {columns.map((column) => (
                <td
                  key={`${row[rowKey]}-${column.key}`}
                  className={[
                    "px-4 py-4 text-sm font-['Inter'] text-[#111827]",
                    column.cellClassName ?? "",
                  ].join(" ")}
                >
                  {column.render ? column.render(row) : row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DashboardDataTable;
